export default __webpack_public_path__ + "static/media/beforeAfterFoto.b58dc917.svg";